import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useContext } from 'react';
import { getComponentName } from './helpers';
export const MatureContext = /*#__PURE__*/ React.createContext(false);
MatureContext.displayName = 'MatureContext';
// HOC for convenience...
export function withMatureContext(Component) {
    const DecoratedComponent = (props)=>{
        const showMatureContent = useContext(MatureContext);
        return /*#__PURE__*/ React.createElement(Component, _extends({
            showMatureContent: showMatureContent
        }, props));
    };
    DecoratedComponent.displayName = `withMatureContext(${getComponentName(Component)})`;
    return DecoratedComponent;
}
